module.exports = __webpack_public_path__ + "img/P1_side_right2.6e4b4709.png";